// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o5CRDW3oMO_8sy5pgpsC{display:flex;gap:2rem;width:80vw;min-height:200px;max-height:550px;height:80vh;min-width:300px;max-width:1000px;padding:1rem;white-space:pre-wrap}.o5CRDW3oMO_8sy5pgpsC .rYkBypmSPQQAIUELy33y{display:flex;flex-direction:column;gap:1rem;width:40%}.o5CRDW3oMO_8sy5pgpsC .BYeT6B1Av5y17xH4fUG9{font-size:1.5rem;font-weight:bold;margin-top:0;color:#6e32f0}.o5CRDW3oMO_8sy5pgpsC .rTsYAtO2SkgI_q6C9E3e{font-size:1rem;line-height:1.5}.o5CRDW3oMO_8sy5pgpsC .FDpcfTDKYOBsRPifm1rk{display:flex;justify-content:center;align-items:center;width:60%}.o5CRDW3oMO_8sy5pgpsC .CqCegbyd8q6zzZX_lclt{object-fit:contain;width:100%;max-height:500px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"content": `o5CRDW3oMO_8sy5pgpsC`,
	"left": `rYkBypmSPQQAIUELy33y`,
	"title": `BYeT6B1Av5y17xH4fUG9`,
	"description": `rTsYAtO2SkgI_q6C9E3e`,
	"right": `FDpcfTDKYOBsRPifm1rk`,
	"image": `CqCegbyd8q6zzZX_lclt`
};
export default ___CSS_LOADER_EXPORT___;
